import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  Progress,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
  Nav,
  NavItem,
  TabContent,
  NavLink,
  TabPane,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import logo from "../../../../assets/images/karak_logo_new.png";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import showNotification from "../../../../helpers/show_notification";
import preloader from "../../../../helpers/preloader";
import printDiv from "../../../../helpers/print_data";
import { columnFreeGoodsDetails, columnsFreeGoods, columnsItem, columnsItemDetails, columnsItemInbound, columnsItemInboundDetails, columnsItemOutbound, columnsItemOutboundDetails, columnsOpeningDetails, columnsPurchase, columnsPurchaseDetails } from "./COGSItemColumns";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import moment from "moment";
import { convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered } from "../../../../helpers/units";
import classnames from "classnames";
import { getDateRangeFromMonth, mergeDuplicateItems, mergeDuplicateItemsQuantity, mergeDuplicateItemsQuantityForOpening, mergeDuplicateItemsQuantityForStore } from "../../../../helpers/commonFunctions";

const flattenDeliveryDetailRows = (rows) =>
  (rows || []).map((row, index) => ({
    ...row,
    row_key: row._id ? `${row._id}_${index}` : `row_${index}`,
    dd_is_free: !!(row.delivery_details && row.delivery_details.is_free),
  }));

const flattenItemDetailRows = (rows) =>
  (rows || []).map((row, index) => ({
    ...row,
    row_key: row._id ? `${row._id}_${index}` : `row_${index}`,
    id_is_free: !!(row.item_details && row.item_details.is_free),
  }));

const CostOfGoodsSoldItemsReport = (props) => {

  const { SearchBar } = Search;
  const [monthYear, setMonthYear] = useState();
  const [currentMonthYear, setCurrentMonthYear] = useState();
  const [selectedRow, setSelectedRow] = useState([]);
  const [filterModalTotal, setFilterModalTotal] = useState(0);
  const [filterModalSubTotal, setFilterModalSubTotal] = useState(0);
  const [filterModalTotalQty, setFilterModalTotalQty] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const ordersRequestId = useRef(0);

  function afterFilter(newResult) {
    const total = (newResult || [])
      .reduce(
        (partialSum, a) => Number(partialSum) + Number(a.receiving_cost || 0),
        0
      )
      .toFixed(2);
    setFilterModalTotal((prev) => (String(prev) === total ? prev : total));
  }

  function afterFilterForDetails(newData, quantityField, detailsType = 'delivery_details') {
     const data = newData || [];
     let totalCost = 0;
     let totalLowestUnitQty = 0;
     
     data.forEach(item => {
       const details = item[detailsType];
       const { 
         receiving_cost = 0,
         cost = 0,
         unit_levels,
         received_quantity,
         receive,
         quantity
       } = details || {};
   
       totalCost += Number(receiving_cost || 0);
   
       if (unit_levels) {
         const quantityToBeDisplayed = 
           quantityField === 'received_quantity' ? received_quantity : 
           quantityField === 'receive' ? receive : 
           quantity;
   
         if (quantityToBeDisplayed) {
           const convertedQty = convertToLowestUnit(unit_levels, quantityToBeDisplayed);
           totalLowestUnitQty += Number(convertedQty || 0);
         }
       }
     });
   
     let displayQuantity = "";
     const firstItemDetails = data[0]?.[detailsType];
     if (firstItemDetails?.unit_levels) {
       const { unit_levels } = firstItemDetails;
       const lowestUnit = unit_levels.at(-1).unit;
       
       const summedQuantity = [{
         unit: lowestUnit,
         value: totalLowestUnitQty
       }];
       
       displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
     }
     const nextSubTotal = totalCost.toFixed(2);
     setFilterModalTotalQty((prev) =>
       JSON.stringify(prev) === JSON.stringify(displayQuantity) ? prev : displayQuantity
     );
     setFilterModalSubTotal((prev) =>
       String(prev) === nextSubTotal ? prev : nextSubTotal
     );
   }

   function afterFilterForOPeningAndClosing(newData, quantityField) {
     const data = newData || [];
     let totalCost = 0;

     data.forEach(item => {
       const details = item;
       const { 
         total_cost = 0,
         unit_levels,
         quantity,
       } = details || {};
   
       totalCost += Number(total_cost || 0);
     });
      const nextTotal = totalCost.toFixed(2);
      setFilterModalTotal((prev) => (String(prev) === nextTotal ? prev : nextTotal));
   }

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
        const previousMonth = moment(currentDay).subtract(1, 'months').format('YYYY-MM');
    setMonthYear(formatDate(currentDay).slice(0, 7));
    // setMonthYear(previousMonth);
    setCurrentMonthYear(formatDate(currentDay).slice(0, 7));
    loadAllBranches()
    // loadOrders();
  }, []);


  const [allOrders, setAllOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allBranches, setAllBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [progress, setProgress] = useState(0);
  const BATCH_SIZE = 10;
  const CONCURRENCY = 2;
  const branchDetailsInFlight = useRef({});

  const loadAllBranches = async () => {
   try {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter((store) => store.type !== "EQUIPMENT STORE"  && store.is_active === true)
      // const res = response.data.filter((store) => (store.type === "CENTRAL STORE" | store.type === "Sub Store" || store.type === "Main Store")  && store.is_active === true)
      // const sorted =  res.sort((a, b) => a.name.localeCompare(b.name)) 
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
   } catch (error) {
    console.error(error)
   }
  };

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      setIsLoading(true);
      setProgress(0);
      setAllOrders([]);

      const url =
        process.env.REACT_APP_BASEURL + "reports/cost_of_goods_sold_items_report";
      const mapBranches = (branches) =>
        (branches || []).map((branch) => ({
          ...branch,
          id: branch.id || branch._id,
        }));

      if (monthYear === currentMonthYear) {
        const branchIds = allBranches.map((branch) => branch._id);
        const batches = [];
        for (let i = 0; i < branchIds.length; i += BATCH_SIZE) {
          batches.push(branchIds.slice(i, i + BATCH_SIZE));
        }
        const totalBatches = batches.length || 1;
        let completed = 0;
        let nextIndex = 0;

        const runWorker = async () => {
          while (nextIndex < batches.length) {
            if (requestId !== ordersRequestId.current) return;
            const index = nextIndex++;
            const payload = {
              monthYear: monthYear,
              branch_ids: batches[index],
              summary_only: true,
            };
            try {
              const batchResponse = await postSubmitForm(url, payload);
              if (requestId !== ordersRequestId.current) return;
              if (batchResponse && batchResponse.status === 1) {
                const newBranchData = mapBranches(
                  batchResponse.data.branches || []
                );
                setAllOrders((prevOrders) => {
                  const newBranchIds = new Set(
                    newBranchData.map((branch) => String(branch._id))
                  );
                  const filteredPrevOrders = prevOrders.filter(
                    (order) => !newBranchIds.has(String(order._id))
                  );
                  return [...filteredPrevOrders, ...newBranchData];
                });
              }
            } catch (batchError) {
              console.error(`Error processing batch ${index + 1}:`, batchError);
            } finally {
              completed += 1;
              setProgress(Math.round((completed / totalBatches) * 100));
            }
          }
        };

        const workers = Math.min(CONCURRENCY, batches.length || 1);
        await Promise.all(
          Array.from({ length: workers }, () => runWorker())
        );
      } else {
        const res = await postSubmitForm(url, {
          monthYear: monthYear,
          summary_only: true,
        });
        if (requestId !== ordersRequestId.current) return;
        if (res.status === 1) {
          setAllOrders(mapBranches(res.data.branches));
        } else {
          showNotification(res.message, "Error");
        }
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return;
      console.error("Error loading orders:", error);
      showNotification("Error loading data", "Error");
    } finally {
      if (requestId === ordersRequestId.current) {
        setProgress(100);
        await new Promise((resolve) => setTimeout(resolve, 400));
        if (requestId === ordersRequestId.current) {
          setIsLoading(false);
        }
      }
    }
  };

useEffect(() => {
    let isMounted = true;
  
    const fetchData = async () => {
      if (monthYear && allBranches.length > 0) {
        setAllOrders([]);
        if (isMounted) {
          await loadOrders();
        }
      }
    };
  
    fetchData();
  
    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [monthYear, allBranches]);


    const [purchaseModal, setPurchaseModal] = useState(false);
    const [openingModal, setOpeningModal] = useState(false);
    const [closingModal, setClosingModal] = useState(false);


    const [itemOutboundModal, setItemOutboundModal] = useState(false);
    const [itemInboundModal, setItemInboundModal] = useState(false);
    const [freeGoodsModal, setFreeGoodsModal] = useState(false);


      const [purchaseDetailsModal, setPurchaseDetailsModal] = useState(false);
      const [itemDetailsModal, setItemDetailsModal] = useState(false);
      const [itemOutboundDetailsModal, setItemOutboundDetailsModal] = useState(false);
      const [itemInboundDetailsModal, setItemInboundDetailsModal] = useState(false);
      const [freeGoodsDetailsModal, setFreeGoodsDetailsModal] = useState(false);

        const [purchaseDetails, setPurchaseDetails] = useState([]);
        const [branchPurchaseDetails, setBranchPurchaseDetails] = useState([]);
        const [itemDetails, setItemDetails] = useState([]);
        const [itemDetailsLevel2, setItemDetailsLevel2] = useState([]);
        const [itemOutboundDetails, setItemOutboundDetails] = useState([]);
        const [itemInboundDetails, setItemInboundDetails] = useState([]);

        const [freeGoodsDetails, setFreeGoodsDetails] = useState([]);
        const [selectedFreeGoods, setSelectedFreeGoods] = useState([]);

        const dateFrom = moment(monthYear).startOf("month").format("YYYY-MM-DD");
        const dateTo = moment(monthYear).endOf("month").format("YYYY-MM-DD");
      // console.log(dateFrom, dateTo);
      
      
      const loadItemOutboundDetails = async (item_id) => {
        try {
          preloader(true);
          let url = process.env.REACT_APP_BASEURL + "reports/branchwise_costing_summary_item_transfers_outbound";
          const response = await postSubmitForm(url, {
            branch_id: selectedBranch._id,
            date_from: dateFrom,
            date_to: dateTo,
            item_id: item_id,
          });
          if (response && response.status === 1) {
            const data = response.data;
      let totalReceivingCost = 0;
      let totalLowestUnitQty = 0;  
      
      data.forEach(item => {
        const { item_details } = item;
        const { 
          receiving_cost = 0,
          unit_levels,
          quantity
        } = item_details || {};

        totalReceivingCost += Number(receiving_cost);

        if (unit_levels && quantity) {
          const convertedQty = convertToLowestUnit(unit_levels, quantity);
          totalLowestUnitQty += Number(convertedQty || 0);
        }
      });

      let displayQuantity = "";
      const firstDeliveryDetails = data[0]?.item_details;
      if (firstDeliveryDetails?.unit_levels) {
        const { unit_levels } = firstDeliveryDetails;
        const lowestUnit = unit_levels.at(-1).unit;
        
        const summedQuantity = [{
          unit: lowestUnit,
          value: totalLowestUnitQty
        }];
        
        displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
      }
            preloader(false);
            setFilterModalSubTotal(totalReceivingCost.toFixed(2));
            setFilterModalTotalQty(displayQuantity);
            setItemOutboundDetails(flattenItemDetailRows(response.data));
            setItemOutboundDetailsModal(true);
          } else {
            preloader(false);
            showNotification(response.message, "Error");
          }
        } catch (error) {
          console.log(error);
        } finally {
          preloader(false)
        }
      };
    
      const loadItemInboundDetails = async (item_id) => {
        try {
          preloader(true);
          let url = process.env.REACT_APP_BASEURL + "reports/branchwise_costing_summary_item_transfers_inbound";
          const response = await postSubmitForm(url, {
            branch_id: selectedBranch._id,
            date_from: dateFrom,
            date_to: dateTo,
            item_id: item_id,
          });
          if (response && response.status === 1) {
            const data = response.data;
      let totalReceivingCost = 0;
      let totalLowestUnitQty = 0;  
      
      data.forEach(item => {
        const { item_details } = item;
        const { 
          receiving_cost = 0,
          unit_levels,
          quantity
        } = item_details || {};

        totalReceivingCost += Number(receiving_cost);

        if (unit_levels && quantity) {
          const convertedQty = convertToLowestUnit(unit_levels, quantity);
          totalLowestUnitQty += Number(convertedQty || 0);
        }
      });

      // Get display quantity if possible
      let displayQuantity = "";
      const firstDeliveryDetails = data[0]?.item_details;
      if (firstDeliveryDetails?.unit_levels) {
        const { unit_levels } = firstDeliveryDetails;
        const lowestUnit = unit_levels.at(-1).unit;
        
        const summedQuantity = [{
          unit: lowestUnit,
          value: totalLowestUnitQty
        }];
        
        displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
      }
            preloader(false);
            setFilterModalSubTotal(totalReceivingCost.toFixed(2));
            setFilterModalTotalQty(displayQuantity);
            setItemInboundDetails(flattenItemDetailRows(response.data));
            setItemInboundDetailsModal(true);
          } else {
            preloader(false);
            showNotification(response.message, "Error");
          }
        } catch (error) {
          console.log(error);
        } finally {
          preloader(false)
        }
      };

      const loadPurchaseDetails = async (item_id,is_requested) => {
        try {
          preloader(true);
          let url = process.env.REACT_APP_BASEURL + "reports/branchwise_costing_summary_po";
          const response = await postSubmitForm(url, {
            branch_id: selectedBranch._id,
            date_from: dateFrom,
            date_to: dateTo,
            from_cogs:true,
            is_requested:is_requested,
            item_id: item_id,
          });
          if (response && response.status === 1) {
            const data = response.data;
      let totalReceivingCost = 0;
      let totalLowestUnitQty = 0;  
      
      data.forEach(item => {
        const { delivery_details } = item;
        const { 
          receiving_cost = 0,
          unit_levels,
          receive
        } = delivery_details || {};

        totalReceivingCost += Number(receiving_cost);

        if (unit_levels && receive) {
          const convertedQty = convertToLowestUnit(unit_levels, receive);
          totalLowestUnitQty += Number(convertedQty || 0);
        }
      });

      let displayQuantity = "";
      const firstDeliveryDetails = data[0]?.delivery_details;
      if (firstDeliveryDetails?.unit_levels) {
        const { unit_levels } = firstDeliveryDetails;
        const lowestUnit = unit_levels.at(-1).unit;
        
        const summedQuantity = [{
          unit: lowestUnit,
          value: totalLowestUnitQty
        }];
        
        displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
      }
            preloader(false);
            setFilterModalSubTotal(totalReceivingCost.toFixed(2));
            setFilterModalTotalQty(displayQuantity);
            setPurchaseDetails(flattenDeliveryDetailRows(response.data));
            setPurchaseDetailsModal(!purchaseDetailsModal);
          } else {
            preloader(false);
            showNotification(response.message, "Error");
          }
        } catch (error) {
          console.log(error);
        } finally {
          preloader(false)
        }
        };
        const loadFreeGoods = async (row) => {
              try {
                preloader(true);
                let url = process.env.REACT_APP_BASEURL + "reports/branch_free_items_summary";
                const response = await postSubmitForm(url, {
                  date_from: dateFrom,
                  date_to: dateTo,
                  branch_id: row._id,
                });
                if (response && response.status === 1) {
                  const data = response.data?.items;
            let totalReceivingCost = 0;
            let totalLowestUnitQty = 0;  
            
            data.forEach(item => {
      
              const { 
                projected_cost = 0,
                unit_levels,
                quantity
              } = item || {};
      
              totalReceivingCost += Number(projected_cost);
      
              if (unit_levels && quantity) {
                const convertedQty = convertToLowestUnit(unit_levels, quantity);
                totalLowestUnitQty += Number(convertedQty || 0);
              }
            });
      
                  preloader(false);
                  setFilterModalTotal(totalReceivingCost.toFixed(2));
                  setFreeGoodsDetails(response.data?.items);
                  setFreeGoodsModal(true);
                } else {
                  preloader(false);
                  showNotification(response.message, "Error");
                }
              } catch (error) {
                console.log(error);
              } finally {
                preloader(false)
              }
            };
      
            const loadFreeGoodsDetails = async (item_id) => {
              try {
                // console.log(item_id,"item");
                
               preloader(true);
           
               let url = process.env.REACT_APP_BASEURL +
                 "reports/branch_free_item_details";
               const response = await postSubmitForm(url, {
                 branch_id: selectedBranch._id,
                 date_from: dateFrom,
                 date_to: dateTo,
                 item_id: item_id,
               });
               if (response && response.status === 1) {
                 const data = response.data;
           let totalReceivingCost = 0;
           let totalLowestUnitQty = 0;  
           data.forEach(item => {
             const { 
               projected_cost = 0,
               unit_levels,
               quantity
             } = item || {};
      
             totalReceivingCost += Number(projected_cost);
      
             if (unit_levels && quantity) {
               const convertedQty = convertToLowestUnit(unit_levels, quantity);
               totalLowestUnitQty += Number(convertedQty || 0);
             }
           });
      
           // Get display quantity if possible
           let displayQuantity = "";
           const firstDeliveryDetails = data[0];
           if (firstDeliveryDetails?.unit_levels) {
             const { unit_levels } = firstDeliveryDetails;
             const lowestUnit = unit_levels.at(-1).unit;
             
             const summedQuantity = [{
               unit: lowestUnit,
               value: totalLowestUnitQty
             }];
             
             displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
           }
                 preloader(false);
                 setFilterModalSubTotal(totalReceivingCost.toFixed(2));
                 setFilterModalTotalQty(displayQuantity);
                 setSelectedFreeGoods(response.data);
                 setFreeGoodsDetailsModal(true);
               } else {
                 preloader(false);
                 showNotification(response.message, "Error");
               }
              } catch (error) {
               console.log(error);
              } finally {
               preloader(false);
              }
           };
        const loadItemDetails = async (item_id) => {
         try {
          preloader(true);
      
          let url = process.env.REACT_APP_BASEURL +
            "reports/branchwise_costing_summary_item_orders";
          const response = await postSubmitForm(url, {
            branch_id: selectedBranch._id,
            date_from: dateFrom,
            date_to: dateTo,
            item_id: item_id,
          });
          if (response && response.status === 1) {
            const data = response.data;
      let totalReceivingCost = 0;
      let totalLowestUnitQty = 0;  
      
      data.forEach(item => {
        const { delivery_details } = item;
        const { 
          receiving_cost = 0,
          unit_levels,
          received_quantity
        } = delivery_details || {};

        totalReceivingCost += Number(receiving_cost);

        if (unit_levels && received_quantity) {
          const convertedQty = convertToLowestUnit(unit_levels, received_quantity);
          totalLowestUnitQty += Number(convertedQty || 0);
        }
      });

      // Get display quantity if possible
      let displayQuantity = "";
      const firstDeliveryDetails = data[0]?.delivery_details;
      if (firstDeliveryDetails?.unit_levels) {
        const { unit_levels } = firstDeliveryDetails;
        const lowestUnit = unit_levels.at(-1).unit;
        
        const summedQuantity = [{
          unit: lowestUnit,
          value: totalLowestUnitQty
        }];
        
        displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
      }
            preloader(false);
            setFilterModalSubTotal(totalReceivingCost.toFixed(2));
            setFilterModalTotalQty(displayQuantity);
            setItemDetailsLevel2(flattenDeliveryDetailRows(response.data));
            setItemDetailsModal(true);
          } else {
            preloader(false);
            showNotification(response.message, "Error");
          }
         } catch (error) {
          console.log(error);
         } finally {
          preloader(false);
         }
        };

      const getPositiveNumber = (value) => {
        const num = Number(value || 0);
        return num > 0 ? num : 0;
      };

      const calculateCOGS = (row) => {
        const cogs =
          Number(row.item_cost_opening ? row.item_cost_opening : 0) +
          Number(row.item_purchase_cost) +
          Number(row.supplier_return_credit_cost) +
          Number(row.item_inbound_transfer_cost) -
          Number(row.item_outbound_transfer_cost) -
          Number(row.item_cost);
        
        return isNaN(cogs) ? 0 : cogs;
      };

  const branchHasDetails = (row) =>
    !!(
      row &&
      (row._detailsLoaded ||
        (row.item_details && row.item_details.length) ||
        (row.item_details_opening && row.item_details_opening.length) ||
        (row.item_purchasebranch_details && row.item_purchasebranch_details.length) ||
        (row.item_purchasebranchdirect_details &&
          row.item_purchasebranchdirect_details.length) ||
        (row.item_order_details && row.item_order_details.length) ||
        (row.item_transfer_details && row.item_transfer_details.length))
    );

  const ensureBranchDetails = async (row) => {
    if (!row || !row._id) return row;
    if (branchHasDetails(row)) return row;
    const rowId = String(row._id);
    if (branchDetailsInFlight.current[rowId]) {
      return branchDetailsInFlight.current[rowId];
    }
    branchDetailsInFlight.current[rowId] = (async () => {
      try {
        const url =
          process.env.REACT_APP_BASEURL +
          "reports/cost_of_goods_sold_items_report";
        const res = await postSubmitForm(url, {
          monthYear,
          branch_ids: [row._id],
          summary_only: false,
        });
        if (res && res.status === 1) {
          const full = (res.data.branches || []).find(
            (branch) => String(branch._id) === rowId
          );
          if (full) {
            const merged = { ...row, ...full, _detailsLoaded: true };
            setAllOrders((prev) =>
              prev.map((branch) =>
                String(branch._id) === rowId
                  ? { ...branch, ...full, _detailsLoaded: true }
                  : branch
              )
            );
            return merged;
          }
        } else {
          showNotification((res && res.message) || "Error", "Error");
        }
      } catch (error) {
        console.error(error);
        showNotification("Error loading details", "Error");
      } finally {
        delete branchDetailsInFlight.current[rowId];
      }
      return row;
    })();
    return branchDetailsInFlight.current[rowId];
  };

      const columns = [
        {
          dataField: "_id",
          hidden: true,
        },
        {
          dataField: "_id",
          formatter: (cell, row, rowIndex) => {
            return rowIndex + 1;
          },
          text: props.t("#"),
          headerStyle: (colum, colIndex) => {
            return { width: "4%" };
          },
        },
        {
          dataField: "name",
          text: props.t("Branch"),
          sort: true,
          formatter: (cell, row, rowIndex) => {
            return (
              <span className="mr-2" >
                {row.name} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
                </span>
            );
          },
           headerStyle: (colum, colIndex) => {
            return { width: "15%" };
          }
        },
        {
          text: props.t("Opening"),
          dataField: "item_cost_opening",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "6%" };
          },
          formatter: (cell, row) => {
            return row.item_cost_opening ? row.item_cost_opening : "0.00";
          },
        },
        {
          dataField: "item_purchase_cost",
          text: props.t("Purchase"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "6%" };
          },
          formatter: (cell, row, rowIndex) => {
            return (
              <span
                className="text-info mr-2"
                title="View Details"
                style={{ cursor: "pointer" }}
                onClick={async () => {
                  const full = await ensureBranchDetails(row);
                  let unique = mergeDuplicateItems(full.item_purchasebranch_details)
                  let unique2 = mergeDuplicateItems(full.item_purchasebranchdirect_details)
                  let itemOrders = mergeDuplicateItems(full.item_order_details)
                  setSelectedRow(unique);
                  setBranchPurchaseDetails(unique2);
                  setItemDetails(itemOrders);
                  setSelectedBranch(full);
                  setFilterModalTotal(full.item_purchase_cost);
                  setPurchaseModal(true);
                }}
              >
                {row.item_purchase_cost ? row.item_purchase_cost : "0.00"}
              </span>
            );
          },
        },
        {
          dataField: "item_outbound_transfer_cost",
          text: props.t("Out Trans"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "6%" };
          },
          formatter: (cell, row, rowIndex) => {
            const isDisabled = row.type !== "Branch";
          
            const handleStoreOutbound = async () => {
              try {
                preloader(true);
                const dateRange = getDateRangeFromMonth(monthYear);
                const startDate = moment(dateRange.startDate);
                const endDate = moment(dateRange.endDate);
                const midDate = moment(dateRange.startDate).date(15);
            
                const firstHalfRange = {
                  dateFrom: startDate.format('YYYY-MM-DD'),
                  dateTo: midDate.format('YYYY-MM-DD')
                };
            
                const secondHalfRange = {
                  dateFrom: midDate.add(1, 'days').format('YYYY-MM-DD'),
                  dateTo: endDate.format('YYYY-MM-DD')
                };
            
                const url = process.env.REACT_APP_BASEURL + "reports/cogs_stores_items_outbound_details";
                
                const [firstHalfResponse, secondHalfResponse] = await Promise.all([
                  postSubmitForm(url, {
                    store_id: row._id,
                    date_from: firstHalfRange.dateFrom,
                    date_to: firstHalfRange.dateTo
                  }),
                  postSubmitForm(url, {
                    store_id: row._id,
                    date_from: secondHalfRange.dateFrom,
                    date_to: secondHalfRange.dateTo
                  })
                ]);
            
                if (firstHalfResponse?.status === 1 && secondHalfResponse?.status === 1) {
                  const mergedData = mergeDuplicateItemsQuantityForStore([
                    ...(firstHalfResponse.data.outbound_details || []),
                    ...(secondHalfResponse.data.outbound_details || [])
                  ],true);
                  // console.log(mergedData.length,"mergedData length")
                  // console.log(firstHalfResponse.data.outbound_details.length + secondHalfResponse.data.outbound_details.length,"response length")
                  const totalofMerge = mergedData.reduce((partialSum, a) => Number(partialSum) + Number(a.receiving_cost),0);
                  // console.log(firstHalfResponse.data.total_outbound_cost+secondHalfResponse.data.total_outbound_cost,"res total")
                  // console.log(totalofMerge,"total");
                  
                  setSelectedBranch(row);
                  setSelectedRow(mergedData);
                  setFilterModalTotal(totalofMerge.toFixed(2));
                  setItemOutboundModal(true);
                } else {
                  showNotification(
                    firstHalfResponse?.message || secondHalfResponse?.message || "Error fetching data", 
                    "Error"
                  );
                }
              } catch (error) {
                console.error("Error fetching store outbound data:", error);
                showNotification("Error loading data", "Error");
              } finally {
                preloader(false);
              }
            };
            const handleBranchOutbound = async () => {
              const full = await ensureBranchDetails(row);
              const filtered = full?.item_transfer_details?.filter(ob => ob.is_outbound) || [];
              const unique = mergeDuplicateItemsQuantity(filtered);
              
              setSelectedBranch(full);
              setSelectedRow(unique);
              setFilterModalTotal(full.item_outbound_transfer_cost);
              setItemOutboundModal(true);
            };
          
            const handleClick = () => {
              if (isDisabled) {
                handleStoreOutbound();
              } else {
                handleBranchOutbound();
              }
            };
          
            return (
              <span
                className="text-info mr-2"
                title="View Details"
                style={{ cursor: "pointer" }}
                onClick={handleClick}
              >
                {row.item_outbound_transfer_cost ? row.item_outbound_transfer_cost : "0.00"}
              </span>
            );
          }
        },
        {
          dataField: "item_inbound_transfer_cost",
          text: props.t("In Trans"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "6%" };
          },
          formatter: (cell, row, rowIndex) => {    
            const isDisabled = row.type !== "Branch";
            return (
              <span
                className={`text-info mr-2 ${isDisabled ? 'text-muted' : ''}`}
                title="View Details"
                style={{ 
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  pointerEvents: isDisabled ? "none" : "auto"
                }}
                disabled={isDisabled}
                onClick={async () => {
                  if (isDisabled) return;
                  const full = await ensureBranchDetails(row);
                  let filtered = full?.item_transfer_details?.filter((ob)=>ob.is_inbound) || []
                  let unique = mergeDuplicateItemsQuantity(filtered); 
                  setSelectedRow(unique);
                  setSelectedBranch(full)
                  setFilterModalTotal(full.item_inbound_transfer_cost);
                  setItemInboundModal(true);
                }}
              >
                {row.item_inbound_transfer_cost ? row.item_inbound_transfer_cost : "0.00"}
              </span>
            );
          },
        },
        {
          text: props.t("Closing"),
          dataField: "item_cost",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "6%" };
          },
          formatter: (cell, row) => {
            const params = `?month=${monthYear}&store_id=${row._id}`;
            const currentMonthYear = moment().format("YYYY-MM")            
            const isDisabled = monthYear !== currentMonthYear 
            const isEmpty = !Number(row?.item_cost) 
            if(!isDisabled){
                return (
                    <Link 
                      to={`/items/branchwise_balance_report${params}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-info"
                      title="View Details"
                    >
                      {cell ? cell : "0.00"}
                    </Link>
                  );
            } else {
      return (
        <span
          className={`${isEmpty ? null : `text-info`}`}
          style={{ cursor: "pointer" }}
          onClick={async () => {
          if(isEmpty) return
          const full = await ensureBranchDetails(row);
          let total = (full.item_details || []).reduce((partialSum, a) => Number(partialSum) + Number(a.total_cost), 0);
          setFilterModalTotal(Number(total.toFixed(2)))
            setSelectedBranch(full);
            setSelectedRow(full.item_details);
              setClosingModal(true)
          }}
          title="View Details"
        >
          {cell ? cell : "0.00"}
        </span>
      );
    }          
          }
        },
        {
          text: props.t("COGS"),
          dataField: "cogs",
          sort: true,
          sortFunc: (a, b, order, dataField, rowA, rowB) => {    
            const cogsA = calculateCOGS(rowA);
            const cogsB = calculateCOGS(rowB);
        
            if (order === 'asc') {
              return cogsA - cogsB;
            }
            return cogsB - cogsA;
          },
          headerStyle: (colum, colIndex) => {
            return { width: "6%" };
          },
          formatter: (cell, row, rowIndex) => {
            return calculateCOGS(row) ? calculateCOGS(row).toFixed(2) : "0.00";
          },
        },
        {
          text: props.t("Used"),
          dataField: "used_item_cost",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "6%" };
          },
          formatter: (cell, row) => {
                  const params = `?month=${monthYear}&store_id=${row._id}`;
                  return (
                    <Link 
                      to={`/items/branchwise_used_cost_report${params}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-info"
                      title="View Details"
                    >
                      {cell ? cell : "0.00"}
                    </Link>
                  );
                },
        },
        {
          text: props.t("Waste"),
          dataField: "waste_item_cost",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          },
          formatter: (cell, row) => {
                  const params = `?month=${monthYear}&store_name=${row.name}`;
                  return (
                    <Link 
                      to={`/items/branchwise_wasted_report${params}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-info"
                      title="View Details"
                    >
                      {cell ? cell : "0.00"}
                    </Link>
                  );
                },
        },
        {
          text: props.t("Discard"),
          dataField: "discard_item_cost",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "6%" };
          },
           formatter: (cell, row) => {
                  const params = `?month=${monthYear}&store_name=${row.name}`;
                  return (
                    <Link 
                      to={`/items/branchwise_discarded_report${params}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-info"
                      title="View Details"
                    >
                      {cell ? cell : "0.00"}
                    </Link>
                  );
                },
        },
        {
          text: props.t("Central Return"),
          dataField: "supplier_return_credit_cost",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          }
        },
        {
          text: props.t("Supplier Return"),
          dataField: "supplier_return_debit_cost",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          }
        },
        {
          dataField: "free_items_cost",
          text: props.t("Used Free"),
          sort: true,
          headerStyle: { width: "5%" },
          formatter: (cell, row, rowIndex) => {
            return (
              <span
                className="text-info mr-2"
                title="View Details"
                style={{ cursor: "pointer" }}
                onClick={() => {
                    loadFreeGoods(row) 
                    setSelectedBranch(row);
                }}
              >
                {row.free_items_cost ? row.free_items_cost : "0.00"}
              </span>
            );
          },
           headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          }
        },
      ];

    const columnPurchase = columnsPurchase(
      props,
      loadPurchaseDetails,
      selectedRow,
      selectFilter,
      dynamicSort,
      false
    );
    const columnPurchaseDirect = columnsPurchase(
      props,
      loadPurchaseDetails,
      selectedRow,
      selectFilter,
      dynamicSort,
      true
    );
    const columnItem = columnsItem(
      props,
      selectFilter,
      loadItemDetails,
      itemDetails,
      dynamicSort
    );
  
    const columnPurchasedetails = columnsPurchaseDetails(props, selectFilter);

    const columnItemdetails = columnsItemDetails(props, selectFilter);
    const columnsOpening = columnsOpeningDetails(props, selectFilter);

  const columnsItemOutBound = columnsItemOutbound(
    props,
    loadItemOutboundDetails,
    selectFilter,
    selectedBranch,
    dynamicSort
    );
  
    const columnsItemOutBoundDetails = columnsItemOutboundDetails(
      props,
      selectFilter,
      itemOutboundDetails,
      dynamicSort
      );
  
  const columnsItemInBound = columnsItemInbound(
    props,
    loadItemInboundDetails,
    selectFilter,
    selectedRow,
    dynamicSort
    );
  
    const columnsItemInBoundDetails = columnsItemInboundDetails(
      props,
      selectFilter,
      itemInboundDetails,
      dynamicSort
      );

         const columnFreeGoods = columnsFreeGoods(
              props,
              loadFreeGoodsDetails,
          );
      
          const columnFreeGoodDetails = columnFreeGoodsDetails(
            props,
        );

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Completed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Booked") {
      style.backgroundColor = "#9ec3ff";
    } else if (row.status === "In Process") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Cancelled") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  const handleDownload = async () => {
    const fileName = `cogs_report_items_${monthYear}`;
    const exportType = "xls";

    let data_to_export = allOrders;
    //console.log(data_to_export);

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        let cogs = calculateCOGS(v)
        if (isNaN(cogs)) {
          cogs = "0.00";
        } else {
          cogs = cogs.toFixed(2);
        }
        data.push({
          Branch: v.name,
          "Opening Cost": v.item_cost_opening,
          "Purchase Cost": v.item_purchase_cost,
          "Outbound Transfer": v.item_outbound_transfer_cost,
          "Inbound Transfer": v.item_inbound_transfer_cost,
          "Closing Cost": v.item_cost,
          COGS: cogs,
          Used: v.used_item_cost,
          Waste: v.waste_item_cost,
          Discard: v.discard_item_cost,
          "Central Return Credit": v.supplier_return_credit_cost,
          "Return Debit": v.supplier_return_debit_cost,
          "Free Cost": v.free_items_cost,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const purchaseOrderTotal = selectedRow?.reduce((acc, cur) => acc + Number(cur.receiving_cost), 0) || 0;
  const itemOrdersTotal = itemDetails?.reduce((acc, cur) => acc + Number(cur.receiving_cost), 0) || 0;
  const directPo = branchPurchaseDetails?.reduce((acc, cur) => acc + Number(cur.receiving_cost), 0) || 0;

 const FormulaExplanation = ({ t }) => (
    <div className="bg-light p-2 mb-4 rounded">
      <h6 className="font-weight-bold mb-3">{t("Formula Explanations")}:</h6>
      <div className="row">
        <div className="col-md-8">
          <p className="mb-2">
            <span className="font-weight-bold">COGS</span> = Opening + Purchase + Central Return + Inbound Transfer - Outbound Transfer - Closing
          </p>
        </div>
        <div className="col-md-4">
          <p className="mb-2">
            <span className="font-weight-bold">Inventory Deductions</span> = Used + Waste + Discard + Supplier Return
          </p>
        </div>
        {/* <div className="col-12">
          <p className="mb-0">
            <span className="font-weight-bold">Difference</span> = |COGS - Used Total|
            <small className="text-muted ml-2">(Absolute difference between COGS and Used Total)</small>
          </p>
        </div> */}
      </div>
    </div>
  );
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("COGS Items - Monthly")}
            title={props.t("COGS Items Reports")}
            breadcrumbItem={props.t("COGS Items - Monthly")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={4} sm={4}>
                      <input
                        type="month"
                        name="monthYear"
                        label={props.t("Month-Year")}
                        value={monthYear}
                        disabled={isLoading}
                        onChange={(e, v) => {
                          setMonthYear(e.target.value);
                        }}
                        max={currentMonthYear}
                        className="is-touched is-pristine av-valid form-control"
                      />
                    </Col>
                    <Col lg={8} sm={8} className="text-right" >
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                {isLoading && 
                <div className="mb-3">
                <Progress
                  animated
                  color="info"
                  value={progress}
                  style={{ height: '20px',color:"Highlight",fontWeight:"bold" }}
                >
                  {Math.round(progress)}%  Loading...
                </Progress>
              </div>
                }
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Cost Of Goods Sold Report (Items)")}
                      <br />
                      {/* <h6>
                        (cogs = opening cost + purchase cost + inbound transfer
                        cost - outbound transfer cost - closing cost)
                      </h6> */}
                    </CardTitle>
                        <FormulaExplanation t={props.t} />
                    <ToolkitProvider
                      keyField="id"
                      data={allOrders && allOrders}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            noDataIndication={
                              isLoading 
                                ? <Spinner size={"md"}/> 
                                : ("No data to display.")
                            }
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                </CardBody>
              </Card>
            </Col>
          </Row>

            {/*Opening  modal  start*/}
                     <Modal
                      size="xl"
                      isOpen={openingModal}
                      toggle={() => setOpeningModal(!openingModal)}
                    >
                      <ModalHeader
                        toggle={() => setOpeningModal(!openingModal)}
                      >
                        {" "}
                        <Link
                          to="#"
                          onClick={() => {
                            printDiv("openingDetailsDiv");
                          }}
                          className="btn btn-sm btn-success mr-2"
                        >
                          <i className="fa fa-print"></i> Print
                        </Link>
                      </ModalHeader>
                      <ModalBody>
                        <Row id="openingDetailsDiv">
                          <Col lg={12}>
                            <Row>
                              <Col lg={4}>
                                {" "}
                                <img
                                  src={logo}
                                  alt=""
                                  height="50"
                                  style={{ borderRadius: "5px" }}
                                />{" "}
                              </Col>
                              <Col lg={4}>
                                <CardTitle className="text-center">
                                {props.t("Cost Of Goods Sold Report (Items)")}
                                </CardTitle>{" "}
                              </Col>
                            </Row>{" "}
                            <CardTitle className="text-center">
                              {props.t("(Opening Cost Details)")}
                            </CardTitle>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12}>
                                  <h5>
                                      Branch : {selectedBranch.name} | Total Cost :{" "}
                                      {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                                    </h5>
                                    <BootstrapTable
                                      keyField="_id"
                                      data={selectedRow && selectedRow}
                                      columns={columnsOpening}
                                      striped
                                      bootstrap4
                                    filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                  setTimeout(() => {
                                    afterFilterForOPeningAndClosing(newResult,"quantity")
                                  }, 200);
                                 return newResult
                              }
                            })}
                                      hover
                                      condensed
                                      {...props.baseProps}
                                    />
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </ModalBody>
                    </Modal>
            {/*Opening  modal  end*/}
            {/*closing  modal  start*/}
                <Modal
                  size="xl"
                  isOpen={closingModal}
                  toggle={() => setClosingModal(!closingModal)}
                >
                  <ModalHeader toggle={() => setClosingModal(!closingModal)}>
                    <Link
                      to="#"
                      onClick={() => printDiv("printDivClosing")}
                      className="btn btn-sm btn-success mr-2"
                    >
                      <i className="fa fa-print"></i> Print
                    </Link>
                  </ModalHeader>
                  <ModalBody>
                    <Row id="printDivClosing">
                      <Col lg={12}>
                        <Row>
                          <Col lg={4}>
                            <img
                              src={logo}
                              alt=""
                              height="50"
                              style={{ borderRadius: "5px" }}
                            />
                          </Col>
                          <Col lg={4}>
                            <CardTitle className="text-center">
                              {props.t("Cost Of Goods Sold Report (Items)")}
                            </CardTitle>
                          </Col>
                        </Row>
                        <CardTitle className="text-center">
                          {props.t("Closing Balance Details")}
                        </CardTitle>
                        <Card>
                          <CardBody>
                            <Row>
                              <Col lg={12}>
                                <h5>
                                  Branch: {selectedBranch?.name} | Total Cost {" "}{filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                                </h5>
                                <BootstrapTable
                                  keyField="_id"
                                  data={selectedRow && selectedRow}
                                  columns={columnsOpening}
                                  striped
                                  hover
                                  condensed
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                  setTimeout(() => {
                                    afterFilterForOPeningAndClosing(newResult,"quantity")
                                  }, 200);
                                 return newResult
                              }
                            })}/>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>
           {/*closing  modal  end*/}
           {/* Purchase breakup modal       */}
           <Modal
            size="xl"
            isOpen={purchaseModal}
            toggle={() => setPurchaseModal(!purchaseModal)}
          >
            <ModalHeader toggle={() => setPurchaseModal(!purchaseModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivPurchaseitem");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
             <ModalBody>
    <Row id="printDivPurchaseitem">
      <Col lg={12}>
        <Row>
          <Col lg={4}>
            <img
              src={logo}
              alt=""
              height="50"
              style={{ borderRadius: "5px" }}
            />
          </Col>
          <Col lg={4}>
            <CardTitle className="text-center">
            {props.t("Cost Of Goods Sold Report (Items)")}
            </CardTitle>
          </Col>
        </Row>
                  <CardTitle className="text-center">
                    {props.t("(Purchase Item Details)")}
                  </CardTitle>
                  <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>

        <Nav tabs className="nav-tabs-custom w-100 mt-2">
          <div className="w-100 d-flex justify-content-center d-print-none">
          <NavItem className="flex-fill text-center">
            <NavLink
              className={classnames({ active: activeTab === "1", "nav-link": true, })}
              onClick={() => setActiveTab("1") }
              style={{ cursor: "pointer" }}
            >
              {props.t("Purchase Details")}
            </NavLink>
          </NavItem>
          <NavItem className="flex-fill text-center">
            <NavLink
              className={classnames({ active: activeTab === "2", "nav-link": true, })}
              onClick={() => setActiveTab("2")}
            >
              {props.t("Direct PO")}
            </NavLink>
          </NavItem>
          <NavItem className="flex-fill text-center">
            <NavLink
              className={classnames({ active: activeTab === "3", "nav-link": true, })}
              onClick={() => setActiveTab("3")}>
              {props.t("Item Order Details")}
            </NavLink>
          </NavItem>
          </div>
        </Nav>

        <TabContent activeTab={activeTab} className="p-3">
          <TabPane tabId="1" key={1}>
            <Card>
              <CardBody>
                <Row>
                              {/* Hidden on screen, visible in print */}
  <h5 className="d-none d-print-block text-center mb-3" 
  style={{display:"flex", justifyContent:"center",textAlign:"center", fontSize:"25px"}}>
    {props.t("Purchase Order")}
  </h5>
  
                  <Col lg={12}>
                  <h5>Total :{" "}{Number(purchaseOrderTotal.toFixed(2).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}))} </h5>
                    <BootstrapTable
                      keyField="_id"
                      data={selectedRow && selectedRow}
                      columns={columnPurchase}
                      striped
                      hover
                      bootstrap4
                      filter={filterFactory({afterFilter})}
                      condensed
                      rowStyle={rowStyle}
                      {...props.baseProps}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </TabPane>

          <TabPane tabId="2" key={2}>
            <Card>
              <CardBody>
                <Row>
                              {/* Hidden on screen, visible in print */}
  <h5 className="d-none d-print-block text-center mb-3" 
  style={{display:"flex", justifyContent:"center",textAlign:"center", pageBreakBefore:"always", fontSize:"25px"}}>
    {props.t("Direct PO")}
  </h5>
                  <Col lg={12}>
                  <h5>Total :{" "}{Number(directPo.toFixed(2).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}))} </h5>
                    <BootstrapTable
                      keyField="_id"
                      data={branchPurchaseDetails && branchPurchaseDetails}
                      columns={columnPurchaseDirect}
                      striped
                      hover
                      bootstrap4
                      filter={filterFactory({afterFilter})}
                      condensed
                      rowStyle={rowStyle}
                      {...props.baseProps}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </TabPane>

          <TabPane tabId="3" key={3}>
            <Card>
              <CardBody>
                <Row>
                   {/* Hidden on screen, visible in print */}
  <h5 className="d-none d-print-block text-center mb-3" 
  style={{display:"flex", justifyContent:"center",textAlign:"center", pageBreakBefore:"always",fontSize:"25px"}}>
    {props.t("Item Order Details")}
  </h5>
                  <Col lg={12}>
                  <h5>Total :{" "}{Number(itemOrdersTotal.toFixed(2).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}))} </h5>
                    <BootstrapTable
                      keyField="_id"
                      data={itemDetails && itemDetails}
                      columns={columnItem}
                      striped
                      hover
                      bootstrap4
                      filter={filterFactory({afterFilter})}
                      condensed
                      rowStyle={rowStyle}
                      {...props.baseProps}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </TabPane>
        </TabContent>
      </Col>
    </Row>
  </ModalBody>
          </Modal>

          {/* Purchase breakup details modal       */}
          <Modal
            size="xl"
            isOpen={purchaseDetailsModal}
            toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
          >
            <ModalHeader
              toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivPurchaseBreakup");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivPurchaseBreakup">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Branchwise Summary Report")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("Purchase Details")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Purchase Item Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Branch: {selectedBranch.name}</h5>
        </div>
        <div>
          <h5 className="mb-0">
            Total Qty: {formatUnitsForReport(filterModalTotalQty)}
          </h5>
        </div>
        <div>
          <h5 className="mb-0">Total: {filterModalSubTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
        </div>
      </div>                      
                          <BootstrapTable
                            keyField="row_key"
                            data={purchaseDetails && purchaseDetails}
                            columns={columnPurchasedetails}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                  setTimeout(() => {
                                    afterFilterForDetails(newResult,"receive","delivery_details")
                                  }, 200);
                                 return newResult
                              }
                            })}
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Item breakup details modal       */}
          <Modal
            size="xl"
            isOpen={itemDetailsModal}
            toggle={() => setItemDetailsModal(!itemDetailsModal)}
          >
            <ModalHeader toggle={() => setItemDetailsModal(!itemDetailsModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitemBreakup");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitemBreakup">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                      {props.t("Cost Of Goods Sold Report (Items)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Item Details")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Item Order Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Branch: {selectedBranch.name}</h5>
        </div>
        <div>
          <h5 className="mb-0">
            Total Qty: {formatUnitsForReport(filterModalTotalQty)}
          </h5>
        </div>
        <div>
          <h5 className="mb-0">Total: {filterModalSubTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
        </div>
      </div>                      

                          <BootstrapTable
                            keyField="row_key"
                            data={itemDetailsLevel2 && itemDetailsLevel2}
                            columns={columnItemdetails}
                            striped
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(newResult,"received_quantity","delivery_details")
                                }, 200);
                                return newResult;
                              }
                            })}
                            hover
                            condensed
                            rowStyle={rowStyle}                       
                             {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Item Outbound modal       */}
          <Modal
            size="xl"
            isOpen={itemOutboundModal}
            toggle={() => setItemOutboundModal(!itemOutboundModal)}
          >
            <ModalHeader
              toggle={() => setItemOutboundModal(!itemOutboundModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitemOutbound");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitemOutbound">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                      {props.t("Cost Of Goods Sold Report (Items)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("(Item Outbound Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsItemOutBound}
                            striped
                            bootstrap4
                            filter={filterFactory({afterFilter})}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Item Outbound breakup details modal       */}
          <Modal
            size="xl"
            isOpen={itemOutboundDetailsModal}
            toggle={() => setItemOutboundDetailsModal(!itemOutboundDetailsModal)}
          >
            <ModalHeader toggle={() => setItemOutboundDetailsModal(!itemOutboundDetailsModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitemOutbounddetails");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitemOutbounddetails">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                      {props.t("Cost Of Goods Sold Report (Items)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Item Outbound")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Item Outbound Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Branch: {selectedBranch.name}</h5>
        </div>
        <div>
          <h5 className="mb-0">
            Total Qty: {formatUnitsForReport(filterModalTotalQty)}
          </h5>
        </div>
        <div>
          <h5 className="mb-0">Total: {filterModalSubTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
        </div>
      </div>                      
                          <BootstrapTable
                            keyField="row_key"
                            data={itemOutboundDetails && itemOutboundDetails}
                            columns={columnsItemOutBoundDetails}
                            striped
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(newResult,"quantity","item_details")
                                }, 200);
                                return newResult;
                              }
                            })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Item Inbound modal       */}
          <Modal
            size="xl"
            isOpen={itemInboundModal}
            toggle={() => setItemInboundModal(!itemInboundModal)}
          >
            <ModalHeader
              toggle={() => setItemInboundModal(!itemInboundModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitemInbound");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitemInbound">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                      {props.t("Cost Of Goods Sold Report (Items)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("(Item Inbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsItemInBound}
                            striped
                            bootstrap4
                            filter={filterFactory({afterFilter})}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

           {/*Item Inbound breakup details modal       */}
           <Modal
            size="xl"
            isOpen={itemInboundDetailsModal}
            toggle={() => setItemInboundDetailsModal(!itemInboundDetailsModal)}
          >
            <ModalHeader toggle={() => setItemInboundDetailsModal(!itemInboundDetailsModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivitemInbounddetails");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivitemInbounddetails">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                      {props.t("Cost Of Goods Sold Report (Items)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Item Inbound Transfer")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Item Inbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Branch: {selectedBranch.name}</h5>
        </div>
        <div>
          <h5 className="mb-0">
            Total Qty: {formatUnitsForReport(filterModalTotalQty)}
          </h5>
        </div>
        <div>
          <h5 className="mb-0">Total: {filterModalSubTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
        </div>
      </div>                      
                                <BootstrapTable
                            keyField="row_key"
                            data={itemInboundDetails && itemInboundDetails}
                            columns={columnsItemInBoundDetails}
                            striped
                            bootstrap4
                            filter={filterFactory({
                              afterFilter: (newResult, targetColumn) => {
                                setTimeout(() => {
                                  afterFilterForDetails(newResult,"quantity","item_details")
                                }, 200);
                                return newResult;
                              }
                            })}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Free Goods modal  */}
                     <Modal
                      size="xl"
                      isOpen={freeGoodsModal}
                      toggle={() => setFreeGoodsModal(!freeGoodsModal)}
                    >
                      <ModalHeader
                        toggle={() => setFreeGoodsModal(!freeGoodsModal)}
                      >
                        {" "}
                        <Link
                          to="#"
                          onClick={() => {
                            printDiv("freeGoodsPrintDiv");
                          }}
                          className="btn btn-sm btn-success mr-2"
                        >
                          <i className="fa fa-print"></i> Print
                        </Link>
                      </ModalHeader>
                      <ModalBody>
                        <Row id="freeGoodsPrintDiv">
                          <Col lg={12}>
                            <Row>
                              <Col lg={4}>
                                {" "}
                                <img
                                  src={logo}
                                  alt=""
                                  height="50"
                                  style={{ borderRadius: "5px" }}
                                />{" "}
                              </Col>
                              <Col lg={4}>
                                <CardTitle className="text-center">
                                {props.t("Cost Of Goods Sold Report (Items)")}
                                </CardTitle>{" "}
                              </Col>
                            </Row>{" "}
                            <CardTitle className="text-center">
                              {props.t("(Free Goods Details)")}
                            </CardTitle>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12}>
                                  <h5>
                                      Branch : {selectedBranch.name} | Total Projected :{" "}
                                      {filterModalTotal}
                                    </h5>
                                    <BootstrapTable
                                      keyField="_id"
                                      data={freeGoodsDetails && freeGoodsDetails}
                                      columns={columnFreeGoods}
                                      striped
                                      bootstrap4
                                      // filter={filterFactory({afterFilter})}
                                      hover
                                      condensed
                                      {...props.baseProps}
                                    />
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </ModalBody>
                    </Modal>
          
                     {/*Free Goods breakup details modal */}
                     <Modal
                      size="xl"
                      isOpen={freeGoodsDetailsModal}
                      toggle={() => setFreeGoodsDetailsModal(!freeGoodsDetailsModal)}
                    >
                      <ModalHeader toggle={() => setFreeGoodsDetailsModal(!freeGoodsDetailsModal)}>
                        {" "}
                        <Link
                          to="#"
                          onClick={() => {
                            printDiv("freeGoodsDetailsPrintDiv");
                          }}
                          className="btn btn-sm btn-success mr-2"
                        >
                          <i className="fa fa-print"></i> Print
                        </Link>
                      </ModalHeader>
                      <ModalBody>
                        <Row id="freeGoodsDetailsPrintDiv">
                          <Col lg={12}>
                            <Row>
                              <Col lg={4}>
                                {" "}
                                <img
                                  src={logo}
                                  alt=""
                                  height="50"
                                  style={{ borderRadius: "5px" }}
                                />{" "}
                              </Col>
                              <Col lg={4}>
                                <CardTitle className="text-center">
                                {props.t("Cost Of Goods Sold Report (Items)")}
                                </CardTitle>{" "}
                              </Col>
                            </Row>{" "}
                            <CardTitle className="text-center">
                              {" "}
                              {props.t("Free Goods")}
                            </CardTitle>
                            <CardTitle className="text-center">
                              {props.t("(Free Goods Item Details)")}
                            </CardTitle>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12}>
                                  <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h5 className="mb-0">Branch: {selectedBranch.name}</h5>
                  </div>
                  <div>
                    <h5 className="mb-0">
                      Total Qty: {formatUnitsForReport(filterModalTotalQty)}
                    </h5>
                  </div>
                  <div>
                    <h5 className="mb-0">Total Projected: {filterModalSubTotal}</h5>
                  </div>
                </div>                      
                                          <BootstrapTable
                                      keyField="_id"
                                      data={selectedFreeGoods && selectedFreeGoods}
                                      columns={columnFreeGoodDetails}
                                      striped
                                      bootstrap4
                                      hover
                                      condensed
                                      {...props.baseProps}
                                    />
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </ModalBody>
                    </Modal>
                    
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(CostOfGoodsSoldItemsReport))
);
